import PayInvoiceButton from "@auer-steel/CustomComponents/PayInvoice/PayInvoiceButton";
import { AuerState } from "@auer-steel/Store/AuerState";
import { getInvoiceState } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { InvoiceHistoryPageContext } from "@insite/content-library/Pages/InvoiceHistoryPage";
import * as React from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: AuerState) => {
    let invoiceTotal = 0;
    state.auerInvoiceHistory.selectedInvoices.forEach(invoiceNumber => {
        const invoice = getInvoiceState(state, invoiceNumber);
        let valueToAdd = 0;
        if (invoice.value && invoice.value.currentBalance > 0) {
            valueToAdd = invoice.value.currentBalance;
        }
        invoiceTotal += valueToAdd;
    });
    return {
        selectedInvoices: state.auerInvoiceHistory.selectedInvoices,
        invoiceTotal,
    };
};

type Props = ReturnType<typeof mapStateToProps> & WidgetProps;

const PayInvoicesLink: React.FunctionComponent<Props> = props => {
    return (
        <PayInvoiceButton
            disabled={props.selectedInvoices?.length < 1 ?? true}
            title={translate("Pay Invoices")}
            invoiceNumbers={props.selectedInvoices ?? []}
            invoiceAmount={props.invoiceTotal}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(PayInvoicesLink),
    definition: {
        group: "Invoice History",
        allowedContexts: [InvoiceHistoryPageContext],
        displayName: "Pay Invoices Button",
    },
};

export default widgetModule;
